import Tooltip from "../Message/Tooltip"

export default function Cards({label, date, value, tooltipText}) {
    return (
        <div className="card ">
            <div className="card-body">
                <div className="d-flex flex-stack mb-2">
                    <h3 className="card-label fw-bolder fs-5 mb-1">{label}</h3>
                    <div className='d-flex flex-column text-end'>
                        <span className="text-muted fw-bold fs-7">{date}</span>
                    </div>
                </div>
                <div className="d-flex text-center flex-column text-dark pt-2">
                    <div className="d-flex flex-wrap align-items-center justify-content-center pt-2">
                        <span className="fw-bolder fs-2x pt-1">{value}</span>
                        <div className="d-flex flex-wrap">
                            <div className="ms-2">
                                <Tooltip message={tooltipText}></Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
